import { z } from 'zod';
export const playerTeamRefSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    short_name: z.string(),
});
export const teamEntitySchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    short_name: z.string(),
    fpl_id: z.number().int(),
    code: z.number().int(),
    strength: z.number().int().nullable().optional(),
    strength_overall_home: z.number().int().nullable().optional(),
    strength_overall_away: z.number().int().nullable().optional(),
    strength_attack_home: z.number().int().nullable().optional(),
    strength_attack_away: z.number().int().nullable().optional(),
    strength_defence_home: z.number().int().nullable().optional(),
    strength_defence_away: z.number().int().nullable().optional(),
    pulse_id: z.number().int().nullable().optional(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
});
/** Team with FPL identifiers (duel detail joins). */
export const teamFplInfoSchema = playerTeamRefSchema.extend({
    fpl_id: z.number(),
    code: z.number(),
});
